// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSweepRunInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subscriptions/admin/sweep/run (S12/#17a)
 *
 * No body, no fields. The round takes no parameters BY DESIGN: the clock is
 * now_gmt3() and the cut policy is the mechanism's, not the caller's. A staff
 * console that could pass its own $now would be a second, unaudited way to move
 * the carência door — exactly the "dois relógios em disjunção" trap the spec
 * names. Clock injection stays a test-only affordance on the service.
 *
 * It exists so the frontend composable can satisfy the canonical
 * `inputContract` option (same precedent as Subscriptions_EventReprocessInput),
 * not because there is anything to validate.
 */
import { registerContract } from './validate'

export interface Subscriptions_AdminSweepRunInput {}

registerContract('Subscriptions_AdminSweepRunInput', {})
